import styled from 'styled-components'

export default styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  padding-bottom: 10vh;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`
